import ReactECharts from "echarts-for-react";

//Props Validations
import PropTypes from "prop-types";

function DriverAnalysisChart({ value = 0, color = "" }) {
    const options = {
        graphic: [
            {
                type: "text",
                left: "center",
                top: "center",
                style: {
                    text: `${value}`,
                    textAlign: "center",
                    fontSize: 12,
                    fontWeight: 600,
                    color: "red",
                },
            },
        ],
        series: [
            {
                name: "Data",
                type: "pie",
                radius: ["60%", "80%"],
                center: ["50%", "55%"],
                startAngle: 180,
                avoidLabelOverlap: false,
                label: {
                    show: false,
                },
                emphasis: {
                    label: {
                        show: false,
                    },
                },
                labelLine: {
                    show: false,
                },
                data: [
                    { value: value, name: "Percentage", itemStyle: { color: color } },
                    { value: 1 - value, name: "", itemStyle: { color: "#D3D3D3" } },
                    {
                        value: 1,
                        itemStyle: {
                            color: "none",
                            decal: {
                                symbol: "none",
                            },
                        },
                        label: {
                            show: false,
                        },
                    },
                ],
            },
        ],
    };

    return (
        <ReactECharts
            option={options}
            style={{ height: "150px" }}
        />
    );
}

// Typechecking props for the DriverAnalysisChart
DriverAnalysisChart.propTypes = {
    value: PropTypes.string,
    color: PropTypes.string,
};

export default DriverAnalysisChart;
